import script from "./PayrollRunManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollRunManagement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__